/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Noinvitations2Inputs */

const zh_organizationsettings_noinvitations2 = /** @type {(inputs: Organizationsettings_Noinvitations2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无待处理邀请`)
};

const en_organizationsettings_noinvitations2 = /** @type {(inputs: Organizationsettings_Noinvitations2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pending invitations`)
};

const es_organizationsettings_noinvitations2 = /** @type {(inputs: Organizationsettings_Noinvitations2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay invitaciones pendientes`)
};

/**
* | output |
* | --- |
* | "No pending invitations" |
*
* @param {Organizationsettings_Noinvitations2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_noinvitations2 = /** @type {((inputs?: Organizationsettings_Noinvitations2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Noinvitations2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_noinvitations2(inputs)
	if (locale === "en") return en_organizationsettings_noinvitations2(inputs)
	return es_organizationsettings_noinvitations2(inputs)
});
export { organizationsettings_noinvitations2 as "organizationSettings_noInvitations" }